import {deleteUser, postAnon, postUser} from "../helper/http";
import { TableRow } from "../types/types.table";
import { 
  FetchTableDataParams, 
  FetchTableDataResponse 
} from "../types/types.table";

export const fetchTableData = async (
  tableName: string,
  params: FetchTableDataParams
): Promise<FetchTableDataResponse> => {
  try {
    let searchParams: any = {
      "module": tableName,
      "page": params.pagination.page.toString(),
      "per_page": params.pagination.limit.toString(),
      "sort_direction": params.sort.direction === "asc" ? '+' : '-',
      "sort_field": 'created_at'
    };

    if (params.filters && Object.keys(params.filters).length) {
      searchParams.filters = params.filters;
    }

    const response = await postUser("crud/list", searchParams);
    
    return {
      data: response.data,
      total: response.total,
      columns: [] 
    };
  } catch (error) {
    console.error("Failed to fetch table data:", error);
    throw new Error("Failed to fetch table data");
  }
};

export const addTableRow = async (
  tableName: string,
  rowData: Omit<TableRow, "id">
): Promise<TableRow> => {
  try {
    const res = await postUser("crud/upsert", {
      body: rowData,
      module: tableName
    });

    return res?.data;
  } catch (error) {
    throw error;
  }
};

export const updateTableRow = async (
  tableName: string,
  rowData: TableRow
): Promise<TableRow> => {
  try {
    const { id, created_at, updated_at, ...body } = rowData as any;
    
    const res = await postUser("crud/upsert", {
      id: Number(id),  
      body: body,
      module: tableName
    });

    return res?.data;
  } catch (error) {
    throw error;
  }
};

export const deleteTableRow = async (
  tableName: string,
  rowId: number
): Promise<void> => {
  try {
    await deleteUser("crud/delete", {
      id: +rowId,
      module: tableName
    });
  } catch (error) {
    throw error;
  }
};

export const duplicateTableRow = async (
  tableName: string,
  rowData: Omit<TableRow, "id">
): Promise<TableRow> => {
  try {
    const res = await postUser("crud/upsert", {
      body: rowData,
      module: tableName
    });

    return res?.data;
  } catch (error) {
    throw error;
  }
};